import contact from './contact'
import banner from './banner'
import resultFeedback from './resultFeedback'
import fileTable from './fileTable'

export default {
  contact,
  banner,
  resultFeedback,
  fileTable
}
